import { render, staticRenderFns } from "./YzCheckboxGroup.vue?vue&type=template&id=34c88e5e&lang=pug&"
import script from "./YzCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./YzCheckboxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports